// Models
import { U21SelectOptionProps } from 'app/shared/u21-ui/components';

import { createSelector } from 'reselect';

import { IconUsers } from '@u21/tabler-icons';

export const selectTeamSearchResults = (state: RootState) => {
  return (
    state.search.teams || {
      data: [],
    }
  );
};

export const selectTeamOptions = createSelector(
  selectTeamSearchResults,
  (teams): U21SelectOptionProps[] =>
    teams.data.map((i) => ({
      icon: <IconUsers />,
      text: i.name,
      value: i.id,
    })),
);
